// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { APPBaseElement } from './APPBaseElement';
import { EnumAPPRelationshipType } from '../../../../../com/MetaPattern/MDA/MD/APPModel/EnumAPPRelationshipType';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 应用类型关系 实体类
 * 应用组件内类型关系
 */
export abstract class APPRelationship extends APPBaseElement {
  /** 应用关系类型 : 应用关系类型 */
  private _aPPRelationshipType: EnumAPPRelationshipType;

  /** 设置：应用关系类型 */
  public get aPPRelationshipType() {
    return this._aPPRelationshipType;
  }

  /** 获取：应用关系类型 */
  public set aPPRelationshipType(value: EnumAPPRelationshipType) {
    this._aPPRelationshipType = value;
  }

  constructor() {
    super();
    this._aPPRelationshipType = EnumAPPRelationshipType.MenuContain;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: APPRelationship, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.aPPRelationshipType = element.aPPRelationshipType;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.aPPRelationshipType = json.APPRelationshipType as EnumAPPRelationshipType;
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.APPRelationshipType = this.aPPRelationshipType;
  }

  protected buildPGContext(context: PGContext): void {
    super.buildPGContext(context);
    // Add row
    context.addRow('基本属性', 'aPPRelationshipType', '应用关系类型', EnumDataType.Reference, this.aPPRelationshipType, true, '应用关系类型', 'EnumAPPRelationshipType', 'PGRowEnumValue');
  }
}
